import $ from 'jquery'; // eslint-disable-line no-restricted-imports
import ImageUI from 'component_ui/image';
import ImageZoomControlsUI from 'component_ui/zoom-controls';
import DetachedDropdown from '@99designs/common/jquery-plugins/detached-dropdown';

$(() => {
    ImageUI.attachTo('[data-image-container]');
    ImageZoomControlsUI.attachTo('[data-image-zoom-controls]');

    DetachedDropdown.createAll('[data-detached-dropdown]');
});



// WEBPACK FOOTER //
// ./src/js/page/profiles-feedback-reviews.js